import { HTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames/bind';

import styles from './Tag.module.css';
const classNamesCtx = classNames.bind(styles);

type TagProps = HTMLAttributes<HTMLDivElement> & {
  text?: string | number;
  dense?: boolean;
  /** Available classes to apply specific color styles to the tag */
  tagStyle?: string; //'import' | 'export' | 'local';
  height?: string | number;
  width?: string | number;
  fontSize?: string;
  align?: string;
  className?: string;
  startIcon?: ReactNode;
};

/**
 * Color coordinated Leg Status Tag component
 */
export default function Tag({ text, dense, tagStyle, startIcon, ...props }: TagProps) {
  if (!text) {
    return <></>;
  }

  const classes = classNamesCtx({
    tag: true,
    dense: dense,
    [props.className ?? '']: Boolean(props.className)
  });

  return (
    <div
      {...props}
      className={`${classes} ${props.className ? props.className : ''} ${tagStyle ? styles[tagStyle] : ''}`}
      style={{
        height: props.height ?? undefined,
        width: props.width ?? undefined,
        fontSize: props.fontSize ?? undefined,
        justifyContent: props.align ?? undefined,
        ...props.style
      }}>
      {startIcon}
      {text}
    </div>
  );
}
